import type { CSSProperties, FC } from 'react';
import React, { useContext } from 'react';
import type { FactorProps } from '../types';
import { ThemeContext } from 'styled-components';

export interface ResidualProps extends FactorProps {
  opacity?: number;
}
const residualStyle: CSSProperties = {
  fill: "url('#summary-diagonal-hatch')",
};

const negativeResidualStyle: CSSProperties = {
  fill: "url('#summary-negative-hatch')",
};

const getStyle = (negative: boolean): CSSProperties => ({
  ...(negative ? negativeResidualStyle : residualStyle),
});

const Residual: FC<React.PropsWithChildren<ResidualProps>> = ({
  opacity = 1,
  x,
  y,
  width,
  height,
  negative = false,
}) => {
  const { Colors } = useContext(ThemeContext);
  return (
    <g>
      {opacity < 1 && <rect fill={Colors.White} fillOpacity={1} x={x} y={y} width={width} height={height} />}
      <rect style={getStyle(negative)} fillOpacity={opacity} x={x} y={y} width={width} height={height} />
    </g>
  );
};

export default Residual;
